import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import "../assets/style.scss"
import Link from "@bappweb/link"
import { useAppSelector } from "../../../config/hook"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import { getQueryStringWithParam } from "src/projects/ticarikredikarti/utils/utils"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"

const LandingHeader = () => {
  let size = useDeviceSize()
  size = size === undefined ? Sizes.md : size
  const isHigherThanMd = size > Sizes.md ? true : false

  const sessionData = useAppSelector((state) => state.sessionData.response)
  
  return (
    <Block className="banner image-top">
      <Block className="container position-relative">
        <Link href="https://www.akbank.com/" className="logo">
          <img className="logo" src={"./img/tkk/logo.svg"} alt="Akbank logosu" />
        </Link>
        <Block type="section" className="section general-features header-text-container" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, !isNullOrEmpty(getQueryStringWithParam("firm")) ? `TicariKrediKarti.Landing.Top.${getQueryStringWithParam("firm")}` : "TicariKrediKarti.Landing.Top") }} />
        {isHigherThanMd &&
          <picture>
            <source
              data-srcset="./img/tkk/ticari-kart.png, ./img/tkk/ticari-kart@2x.png 2x"
              data-src="./img/tkk/transparent.png"
            />
            <img
              className="lazyload img-fluid banner-img"
              src={"./img/tkk/ticari-kart.png"}
              alt="Axess Business ve Wings Business ticari kredi kartları görseli"
            />
          </picture>
        }
      </Block>
    </Block>
  )
}

export default LandingHeader
